/**
 * 사업장(field) 삭제 권한. 서버(DeleteFieldController)와 같은 기준으로 화면의 삭제 버튼을 표시한다.
 * - 시스템 관리자는 항상 가능
 * - 프로젝트에 "사업장 편집은 매니저 전용"(field_edit_by_manager_only)이 켜져 있으면 프로젝트 관리자만,
 *   꺼져 있으면 프로젝트 참여자 모두 가능
 *
 * @param {Object} store Vuex store (컴포넌트에서는 this.$store)
 * @param {String|Number} projectId 프로젝트 ID
 * @returns {boolean}
 */
export function canDeleteField(store, projectId) {
  const userInfo = store.state.auth.userInfo || {};
  if (parseInt(userInfo.is_superuser) > 0) return true;

  const memberInfo = store.state.member.memberInfo;
  if (!memberInfo) return false;
  if (memberInfo.is_superuser) return true;

  const project = (memberInfo.projects || []).find((p) => `${p.id}` === `${projectId}`);
  if (!project) return false;

  const projectInfo = store.state.project.projectInfo || {};
  if (projectInfo.field_edit_by_manager_only) {
    return !!(project.pivot && project.pivot.is_manager);
  }
  return true;
}
